import { render, staticRenderFns } from "./AnularSunat.vue?vue&type=template&id=1296e477"
import script from "./AnularSunat.vue?vue&type=script&lang=js"
export * from "./AnularSunat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports